var TorsoBehavior = require('backbone-torso/modules/Behavior');
var ModalDialogWidget = require('./../../widget/modal/ModalDialogWidget');

/**
 * If attempting to navigate away from a page, will open a confirmation modal
 * Will open a modal if:
 * - 'home' event triggered on view
 * - 'browserBack' event triggered on view
 * - 'click' happens on view's '[data-back-link]'
 *
 * NOTE: a view that uses this behavior must also use UseModalBehavior.
 *
 * @class AppointmentNavigationConfirmBehavior
 * @constructor
 * @param behaviorOptions {Object} for behavior
 * @param viewOptions {Object} view initialization
 * @param viewOptions.patientVecnaId {String} of patient
 */
module.exports = TorsoBehavior.extend({

  events: {
    'click [data-back-link]': '_openBackModalFromBackLink'
  },

  GO_HOME: 'go home',
  GO_BACK: 'go back',

  mixin: {
    /**
     * @method isNavigateAwayConfirmed
     * @returns {Boolean} true if navigating away from this perspective has been confirmed by the user.
     */
    isNavigateAwayConfirmed: function() {
      return this.get('isNavigateAwayConfirmed');
    }
  },

  /**
   * @method initialize
   * @param attributes {Object}
   * @param behaviorOptions {Object}
   * @param viewOptions {Object}
   * @override
   */
  initialize: function(attributes, behaviorOptions, viewOptions) {
    this.set('isNavigateAwayConfirmed', false);
    viewOptions = viewOptions || {};
    this._patientVecnaId = viewOptions.patientVecnaId;
  },

  /**
   * Stops event default event propagation before opening the modal (i.e. if this was triggered by a link then it stop nav).
   * @method _openBackModalFromHomeEvent
   * @param event {Event}
   * @private
   */
  _openBackModalFromHomeEvent: function(event) {
    event.preventDefault();
    this._openBackModal(this.GO_HOME);
  },

  /**
   * Open back modal from clicking the back-link on the page
   *
   * @method _openBackModalFromBackLink
   * @param event {Event}
   * @private
   */
  _openBackModalFromBackLink: function(event) {
    event.preventDefault();
    this._openBackModal(this.GO_BACK);
  },

  /**
   * Called when a browser navigate to the staff-facing patient appointments page is triggered and this view has not had that action confirmed.
   * @method openBackModalFromBackEvent
   */
  _openBackModalFromBackEvent: function() {
    this._openBackModal(this.GO_BACK);
  },

  /**
   * Sets the back confirm modal view to render.
   * @method _openBackModal
   * @param destination {String} this.GO_HOME for home, this.GO_BACK for back
   * @private
   */
  _openBackModal: function(destination) {
    var dataViewName, location, descriptionKey, yesKey;
    if (destination === this.GO_HOME) {
      dataViewName = 'confirm navigation home';
      location = '/patient-portal/ereg.html#staff/patient';
      descriptionKey = 'eregStaffPlaceholderAppointment.configure.backConfirmModal.body.home';
      yesKey = 'eregStaffPlaceholderAppointment.backConfirmModal.homeButton';
    } else if (destination === this.GO_BACK) {
      dataViewName = 'confirm navigation back';
      location = '/patient-portal/ereg.html#staff/patient/' + this._patientVecnaId + '/appointment';
      descriptionKey = 'eregStaffPlaceholderAppointment.configure.backConfirmModal.body.return';
      yesKey = 'eregStaffPlaceholderAppointment.backConfirmModal.returnButton';
    }

    // cancel previous modal if there is one
    if (this._modalDialogWidget) {
      this._modalDialogWidget.cancel();
    }

    this._modalDialogWidget = new ModalDialogWidget({
      className: 'brec-dialog brec-dialog--regular',
      dataViewName: dataViewName,
      headerKey: 'eregStaffPlaceholderAppointment.backConfirmModal.header',
      closeTitleKey: 'eregAuth.modal.close',
      descriptionKey: descriptionKey,
      yesKey: yesKey,
      noKey: 'eregStaffPlaceholderAppointment.backConfirmModal.stayButton',
      noPrimary: true
    });

    var self = this;
    this.view.showModal(this._modalDialogWidget, function() {
      self.set('isNavigateAwayConfirmed', true);
      window.location.href = location;
    });
  },

  /**
   * Clear navigation confirm on attaching the view, instead of detaching
   * so that other views can continue to read the ultimate state of the modal
   *
   * Also listen to events for opening the modal.
   *
   * @method _attached
   */
  _attached: function() {
    this.set('isNavigateAwayConfirmed', false);
    this.listenTo(this.view, 'home', this._openBackModalFromHomeEvent);
    this.listenTo(this.view, 'browserBack', this._openBackModalFromBackEvent);
  },

  /**
   * When detached, stop listening to opening events.
   *
   * @method _detached
   */
  _detached: function() {
    this.stopListening(this.view, 'home');
    this.stopListening(this.view, 'browserBack');
  }
});
